import type { Person } from '../../../model/types.tsx';

export const REQUEST_CURRENT_USER = 'state.actions.user.REQUEST_CURRENT_USER' as const;
export const SET_CURRENT_USER = 'state.actions.user.SET_CURRENT_USER' as const;

export type RequestCurrentUserAction = {
	type: typeof REQUEST_CURRENT_USER;
};

export const requestCurrentUser = (): RequestCurrentUserAction => ({
	type: REQUEST_CURRENT_USER,
});

export type SetCurrentUserAction = {
	type: typeof SET_CURRENT_USER;
	payload: Person;
};

export const setCurrentUser = (payload: Person) => ({
	type: SET_CURRENT_USER,
	payload,
});

export type Action = RequestCurrentUserAction | SetCurrentUserAction;
